import { useMutation, useQueryClient } from 'react-query'
import { useSnackbar } from 'notistack'
import { updateZone } from 'services/cm-api/update-zone'
import { ErrorResponseT } from 'types'

/**
 * Wraps `PUT /global-data/update-zone`. On success it invalidates the
 * global-zones list. Callers may pass `onSuccess`/`onError` to drive their own
 * (localized) snackbars and dialog close; otherwise English fallbacks are used.
 */
export function useUpdateZone({
  onSuccess,
  onError,
}: { onSuccess?: Function; onError?: Function } = {}) {
  const queryClient = useQueryClient()
  const { enqueueSnackbar } = useSnackbar()

  return useMutation(updateZone, {
    onSuccess: async (response) => {
      if (response.success) {
        await queryClient.invalidateQueries(['getGlobalZones'])
        if (onSuccess) {
          onSuccess(response.data)
        } else {
          enqueueSnackbar('Custom zone updated', { variant: 'success' })
        }
        return
      }
      if (onError) {
        onError((response as ErrorResponseT).error)
      } else {
        enqueueSnackbar('Failed to update custom zone', { variant: 'error' })
      }
    },
    onError: (err) => {
      if (onError) {
        onError(err)
      } else {
        enqueueSnackbar('Failed to update custom zone', { variant: 'error' })
      }
      console.error('updateZone failed: ', err)
    },
  })
}
